import { ENDPOINTS_MANAGER } from 'common/endpoints/food-benefit.endpoints';
import managerAssembler from './managerRepository.assemblers';

class managerRepositoryService {
  constructor($http, ManagerDataService) {
    'ngInject';
    this.http = $http;
    this.ManagerDataService = ManagerDataService;
  }

  getManager(managerId) {
    return this.http.get(ENDPOINTS_MANAGER.get.initial(managerId)).then(response => {
      return managerAssembler.assemble(response.data);
    });
  }
}

export default managerRepositoryService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/managerRepository/managerRepository.service.js